import { render, staticRenderFns } from "./CargoInformation.vue?vue&type=template&id=ded28214&scoped=true&"
import script from "./CargoInformation.vue?vue&type=script&lang=js&"
export * from "./CargoInformation.vue?vue&type=script&lang=js&"
import style0 from "./CargoInformation.vue?vue&type=style&index=0&id=ded28214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded28214",
  null
  
)

/* custom blocks */
import block0 from "./CargoInformation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports